// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-change-log-details-listing .changeLogDetailContainer .changeLogDetailHeader {
  display: flex;
  flex-direction: row;
  padding: 15px;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogDetailHeader .title {
  font-weight: 600;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogFilterRow {
  display: flex;
  flex-direction: row;
  padding: 15px;
  background: whitesmoke;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogFilterRow .filterContainer {
  margin-right: 12px;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogFilterRow .filterContainer i {
  color: #a29ffa;
  padding-right: 5px;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogSearchRow {
  display: flex;
  flex-direction: row;
  padding: 15px;
}
app-change-log-details-listing .changeLogDetailContainer .userNameContainer {
  flex: 0 0 90px;
}
app-change-log-details-listing .changeLogDetailContainer .nameContainer {
  flex: 0 0 140px;
}
app-change-log-details-listing .changeLogDetailContainer .dateTimeContainer {
  flex: 0 1 190px;
}
app-change-log-details-listing .changeLogDetailContainer .actionContainer {
  flex: 0 1 380px;
}
app-change-log-details-listing .changeLogDetailContainer .settingContainer {
  flex: 1 1 380px;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogDetailHeaderContainer {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogDetailHeaderContainer .headerContainer {
  font-weight: 600;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogDetailRow {
  display: flex;
  flex-direction: row;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogDetailRow .userNameContainer {
  padding-bottom: 16px;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogDetailRow .nameContainer {
  padding-bottom: 16px;
  border-left: 1px solid #5484ff;
  padding-left: 10px;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogDetailRow .dateTimeContainer {
  padding-bottom: 16px;
  border-left: 1px solid #5484ff;
  padding-left: 10px;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogDetailRow .actionContainer {
  padding-bottom: 16px;
  border-left: 1px solid #5484ff;
  padding-left: 10px;
}
app-change-log-details-listing .changeLogDetailContainer .changeLogDetailRow .settingContainer {
  padding-bottom: 16px;
  border-left: 1px solid #5484ff;
  padding-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/decision-grid/Components/change-log/change-log-details-listing/change-log-details-listing.component.less"],"names":[],"mappings":"AAAA;EAMM,aAAA;EACA,mBAAA;EAEA,aAAA;AALN;AAJA;EAYQ,gBAAA;AALR;AAPA;EAkBM,aAAA;EACA,mBAAA;EAEA,aAAA;EACA,sBAAA;AATN;AAbA;EAyBQ,kBAAA;AATR;AAhBA;EA4BU,cAAA;EACA,kBAAA;AATV;AApBA;EAoCM,aAAA;EACA,mBAAA;EACA,aAAA;AAbN;AAzBA;EA0CM,cAAA;AAdN;AA5BA;EA8CM,eAAA;AAfN;AA/BA;EAkDM,eAAA;AAhBN;AAlCA;EAsDM,eAAA;AAjBN;AArCA;EA0DM,eAAA;AAlBN;AAxCA;EA+DM,aAAA;EACA,mBAAA;EAEA,iBAAA;EACA,oBAAA;AArBN;AA9CA;EAsEQ,gBAAA;AArBR;AAjDA;EA4EM,aAAA;EACA,mBAAA;AAxBN;AArDA;EAgFQ,oBAAA;AAxBR;AAxDA;EAoFQ,oBAAA;EACA,8BAAA;EACA,kBAAA;AAzBR;AA7DA;EA0FQ,oBAAA;EACA,8BAAA;EACA,kBAAA;AA1BR;AAlEA;EAgGQ,oBAAA;EACA,8BAAA;EACA,kBAAA;AA3BR;AAvEA;EAsGQ,oBAAA;EACA,8BAAA;EACA,kBAAA;AA5BR","sourcesContent":["app-change-log-details-listing {\n\n  .changeLogDetailContainer {\n\n    .changeLogDetailHeader {\n\n      display: flex;\n      flex-direction: row;\n\n      padding: 15px;\n\n      .title {\n        font-weight: 600;\n      }\n    }\n\n    .changeLogFilterRow {\n\n      display: flex;\n      flex-direction: row;\n\n      padding: 15px;\n      background: whitesmoke;\n\n      .filterContainer {\n        margin-right: 12px;\n\n        i {\n          color: #a29ffa;\n          padding-right: 5px;\n        }\n      }\n    }\n\n    .changeLogSearchRow {\n\n      display: flex;\n      flex-direction: row;\n      padding: 15px;\n    }\n\n    .userNameContainer {\n      flex: 0 0 90px;\n    }\n\n    .nameContainer {\n      flex: 0 0 140px;\n    }\n\n    .dateTimeContainer {\n      flex: 0 1 190px;\n    }\n\n    .actionContainer {\n      flex: 0 1 380px;\n    }\n\n    .settingContainer {\n      flex: 1 1 380px;\n    }\n\n    .changeLogDetailHeaderContainer {\n\n      display: flex;\n      flex-direction: row;\n\n      padding-top: 20px;\n      padding-bottom: 20px;\n\n      .headerContainer {\n        font-weight: 600;\n      }\n    }\n\n    .changeLogDetailRow {\n\n      display: flex;\n      flex-direction: row;\n\n      .userNameContainer {\n        padding-bottom: 16px;\n      }\n\n      .nameContainer {\n        padding-bottom: 16px;\n        border-left: 1px solid #5484ff;\n        padding-left: 10px;\n      }\n\n      .dateTimeContainer {\n        padding-bottom: 16px;\n        border-left: 1px solid #5484ff;\n        padding-left: 10px;\n      }\n\n      .actionContainer {\n        padding-bottom: 16px;\n        border-left: 1px solid #5484ff;\n        padding-left: 10px;\n      }\n\n      .settingContainer {\n        padding-bottom: 16px;\n        border-left: 1px solid #5484ff;\n        padding-left: 10px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
